export const SUBSCRIBERS_IMPORT_LIST_PATH = "/si";
export const SUBSCRIBERS_IMPORT_CREATE_VIEW_PATH = "/si/create";
